// extracted by mini-css-extract-plugin
export default {"sectionBody":"chips-section_sectionBody__SCylZ","chip":"chips-section_chip__5QPgX"};